import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { parseISO } from 'date-fns';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import TimetableSearchResult from './Timetable/TimetableSearchResult.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimetableResult',
  props: {
    from: {},
    to: {},
    departureDate: {}
  },
  setup(__props: any) {



const router = useRouter();

// eslint-disable-next-line vue/no-dupe-keys
const from = ref<string>(router.currentRoute.value.params.from.toString());
// eslint-disable-next-line vue/no-dupe-keys
const to = ref<string>(router.currentRoute.value.params.to.toString());
const departureDateString = parseISO(`${router.currentRoute.value.params.departureDate.toString()}Z`).toISOString();
// eslint-disable-next-line vue/no-dupe-keys
const departureDate = ref(departureDateString);

watch(() => router.currentRoute.value, (route) => {
  from.value = decodeURI(route.params.from.toString());
  to.value = decodeURI(route.params.to.toString());
  departureDate.value = parseISO(`${route.params.departureDate.toString()}Z`).toISOString();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TimetableSearchResult, {
    from: from.value.toString(),
    to: to.value.toString(),
    "departure-date": departureDate.value
  }, null, 8, ["from", "to", "departure-date"]))
}
}

})